import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Discriminator type selector for discriminated unions.
 * Used in both array item headers (xs) and standalone union fields (md).
 */
export function DiscriminatorSelect({ path, value, options, onChange, disabled, readOnly, size = 'md', fullWidth = true }) {
    const sizeClass = size === 'xs' ? 'select-xs' : 'select-sm';
    const styleClass = size === 'xs' ? 'select-bordered' : '';
    const widthClass = fullWidth ? 'w-full' : 'w-auto';
    const shrinkClass = size === 'xs' ? 'shrink-0' : '';
    return (_jsxs("select", { name: `${path}._type`, className: `select ${styleClass} ${sizeClass} ${widthClass} ${shrinkClass}`.trim(), value: value ?? '', onChange: (e) => onChange(e.target.value), disabled: disabled || readOnly, "aria-label": "Select type", children: [_jsx("option", { value: "", disabled: true, children: "Select type..." }), options.map((opt) => (_jsx("option", { value: opt.value, children: opt.label }, opt.value)))] }));
}
